import OfferGoldSoftCard from './OfferGoldSoftCard.vue'

export default {
  /**
   * app.use(OfferGoldSoftPlugin, { name: 'OfferGoldCard' })
   */
  install(app, options = {}) {
    const name = options.name || 'OfferGoldSoftCard'
    app.component(name, OfferGoldSoftCard)
  }
}

export { OfferGoldSoftCard }
